import { useInfiniteQuery } from 'react-query'
import { getRejectedDemandLoans, TDecidedSort } from 'services/loans'

export default function useGetRejectedDemandLoans(
    id: string | undefined,
    sort: TDecidedSort = 'decided_newest'
) {
    const { data, isLoading, fetchNextPage, refetch } = useInfiniteQuery(
        ['money-pools-fund-loans-rejected', id, sort],
        ({ pageParam = 1 }) => getRejectedDemandLoans(pageParam, id, sort),
        {
            getNextPageParam: (lastPage, allPages) => {
                const lastRecord = allPages[allPages.length - 1]?.next || ''
                return lastRecord
                    ? new URL(lastRecord).searchParams.get('page')
                    : undefined
            },
        }
    )
    return {
        demandLoans: data,
        isLoadingDemandLoans: isLoading,
        refetch,
        fetchNextPage,
    }
}
